import router from '@configs/router';
import React from 'react';
import { useErrorBoundary, ErrorBoundary } from 'react-error-boundary';

export const ErrorFallback = () => {
  const { resetBoundary } = useErrorBoundary();
  const goHome = () => {
    router.navigate({ to: '/' });
  };

  return (
    <div className="flex items-center justify-center w-full h-full">
      <div role="alert" className="flex flex-col items-center justify-center ">
        <p className="font-semibold">Something went wrong</p>
        <div className="flex flex-row items-center gap-5 mt-10">
          <div className="overflow-hidden border border-red-400 rounded-full hover:bg-red-300">
            <button onClick={resetBoundary} className="p-2">
              Try again
            </button>
          </div>
          <div className="overflow-hidden border rounded-full hover:bg-primary/40 border-primary">
            <button onClick={goHome} className="p-2 ">
              Go home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const onError = (error) => {
  console.log(error);
};

export const ComponentErrorBoundary = ({ children }) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={onError}>
      {children}
    </ErrorBoundary>
  );
};
